import './BlockedApplicationAlert.scss';

import { ApproveApplicationButton } from './ApproveApplicationButton';
import { BlockInSalesforceButton } from './BlockInSalesforceButton';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DataSecurityApplicationStatus } from '@sonar-software/sonar-core';
import React from 'react';
import { useApplicationReference } from '@hooks';

import { Alert, Flex, Space } from 'antd';

export interface BlockedApplicationAlertProps {
	applicationId?: number;
	dashboard?: boolean;
}

export const BlockedApplicationAlert: React.FC<BlockedApplicationAlertProps> = ({ applicationId = 0, dashboard }) => {
	const { status } = useApplicationReference(applicationId);

	if (applicationId && status !== DataSecurityApplicationStatus.Blocked) {
		return null;
	}

	return (
		<Alert
			className={ classNames('blocked-application-alert', { 'dashboard-alert': dashboard }) }
			closable
			message={
				<Flex justify='space-between'>
					{ COPY_SPECIFIC.APPLICATION_CURRENTLY_BLOCKED }
					{ Boolean(applicationId) &&
						<Space>
							<BlockInSalesforceButton />
							<ApproveApplicationButton
								applicationId={ applicationId }
								size='small' />
						</Space> }
				</Flex>
			}
			showIcon
			type='error' />
	);
};
